import { render, staticRenderFns } from "./OnboardingProfilePicture.vue?vue&type=template&id=6c96273b&"
import script from "./OnboardingProfilePicture.vue?vue&type=script&lang=ts&"
export * from "./OnboardingProfilePicture.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports